import { createSlice } from '@reduxjs/toolkit';
import permissions from './permissions';

const initialState = {
  permissions: {},
  simulateUserView: false,
};
export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: () => {},
    loginSuccess: (state, { payload }) => {
      return {
        ...state,
        ...payload,
        permissions: {
          ...(permissions[payload.claims?.userData?.role] ?? {}),
          ...(payload.claims?.userData?.additionalPermissions ?? {}),
        },
        level: payload.claims?.userData?.role
          ? permissions.levels.find(
              ({ role }) => payload.claims.userData.role === role
            )
          : {},
      };
    },
    loginFail: () => initialState,
    logout: () => initialState,
    setRole: (state, { payload }) => {
      state.permissions = permissions[payload];
      state.level = permissions.levels.find(({ role }) => payload === role);
    },
    setSimulateUserView: (state, { payload }) => {
      state.simulateUserView = payload;
    },
  },
});

export const authActions = authSlice.actions;

export default authSlice.reducer;
